import { Button, Modal, Row, Col } from "antd";

const ShowDetail = ({ open, close, fileUrl }) => {
    return (
        <Modal
            open={open}
            // onCancel={close}
            footer={null}
            width={800}
            closable={false}
        >
            {fileUrl ? (
                <iframe
                    src={fileUrl}
                    width="100%"
                    height="600px"
                    style={{ border: "none" }}
                    title="PDF Viewer"
                />
            ) : (
                "ไม่พบไฟล์ PDF"
            )}
            <Row justify="end" style={{ marginTop: 16 }}>
                <Col>
                    <Button
                        danger
                        shape="round"
                        // icon={<DeleteOutlined />}
                        onClick={close}
                    >
                        close
                    </Button>
                </Col>
            </Row>
        </Modal>
    );
};

export default ShowDetail;